// Error403.jsx
import React, { useState, useEffect } from "react";
//import "./Error403.css"; // o usa estilos inline

function Error403() {
  const [ipPublica, setIpPublica] = useState("Obteniendo...");

  useEffect(() => {
    fetch("https://checkip.amazonaws.com")
      .then((res) => res.text())
      .then((data) => setIpPublica(data.trim()))
      .catch(() => setIpPublica("No disponible"));
  }, []);

  return (
    <div style={styles.wrap}>
      <div style={styles.card}>

        <span style={styles.codeTag}>HTTP 403 — Prohibido</span>

        {/* Número 403 + candado superpuesto */}
        <div style={styles.codeBlock}>
          <div style={styles.number}>403</div>

          <svg
            style={styles.lockIcon}
            viewBox="0 0 64 64"
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="64"
          >
            {/* Cuerpo del candado */}
            <rect x="10" y="30" width="44" height="30" rx="6" fill="#1a1a2e" />
            {/* Arco del candado */}
            <path
              d="M20 30V22a12 12 0 0 1 24 0v8"
              fill="none"
              stroke="#1a1a2e"
              strokeWidth="5"
              strokeLinecap="round"
            />
            {/* Ojo de la cerradura */}
            <circle cx="32" cy="44" r="4" fill="white" />
            <line x1="32" y1="48" x2="32" y2="53" stroke="white" strokeWidth="3" strokeLinecap="round" />
          </svg>
        </div>

        <h1 style={styles.title}>Acceso denegado</h1>
        <div style={styles.divider} />
        <p style={styles.desc}>
          No tienes los permisos necesarios para ver esta página.
          Si crees que esto es un error, comunícate con el administrador del sistema.
        </p>

        <div style={styles.ipBox}>
          <span style={styles.ipLabel}>Tu IP pública:</span>
          <span style={styles.ipValue}>{ipPublica}</span>
        </div>

        <div style={styles.actions}>
          <button style={styles.btnPrimary} onClick={() => window.history.back()}>
            ← Volver atrás
          </button>
          <button style={styles.btnSecondary} onClick={() => window.location.href = "/"}>
            Ir al inicio
          </button>
        </div>

        <p style={styles.footer}>
          Copyright &copy; {new Date().getFullYear()} SkyAngel
        </p>
      </div>
    </div>
  );
}

const styles = {
  wrap: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f4f6f8",
    fontFamily: "'Segoe UI', Arial, sans-serif",
    padding: "2rem",
  },
  card: {
    maxWidth: "480px",
    width: "100%",
    textAlign: "center",
    backgroundColor: "#ffffff",
    borderRadius: "16px",
    padding: "2.5rem 2rem",
    boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
  },
  codeTag: {
    display: "inline-block",
    fontFamily: "monospace",
    fontSize: "11px",
    backgroundColor: "#f0f0f5",
    color: "#666",
    padding: "3px 10px",
    borderRadius: "4px",
    border: "1px solid #e0e0e8",
    marginBottom: "1.5rem",
    letterSpacing: "0.05em",
  },
  codeBlock: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "1.5rem",
  },
  number: {
    fontSize: "7rem",
    fontWeight: "800",
    lineHeight: "1",
    letterSpacing: "-4px",
    color: "#ebebf0",
    WebkitTextStroke: "2px #d0d0da",
    userSelect: "none",
  },
  lockIcon: {
    position: "absolute",
    width: "64px",   // ← tamaño fijo explícito
    height: "64px",  // ← tamaño fijo explícito
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -52%)",
  },
  title: {
    fontSize: "1.4rem",
    fontWeight: "700",
    color: "#1a1a2e",
    margin: "0 0 0.5rem",
  },
  divider: {
    width: "36px",
    height: "3px",
    backgroundColor: "#e0e0e8",
    margin: "0.75rem auto 1rem",
    borderRadius: "2px",
  },
  desc: {
    fontSize: "0.9rem",
    color: "#666",
    lineHeight: "1.7",
    margin: "0 auto 2rem",
    maxWidth: "380px",
  },
  actions: {
    display: "flex",
    gap: "12px",
    justifyContent: "center",
    flexWrap: "wrap",
    marginBottom: "1.5rem",
  },
  btnPrimary: {
    backgroundColor: "#1a1a2e",
    color: "#fff",
    border: "none",
    padding: "0.55rem 1.4rem",
    borderRadius: "8px",
    fontSize: "0.875rem",
    fontWeight: "600",
    cursor: "pointer",
  },
  btnSecondary: {
    backgroundColor: "transparent",
    color: "#1a1a2e",
    border: "1px solid #d0d0da",
    padding: "0.55rem 1.4rem",
    borderRadius: "8px",
    fontSize: "0.875rem",
    fontWeight: "500",
    cursor: "pointer",
  },
  footer: {
    fontSize: "11px",
    color: "#bbb",
    margin: "0",
  },
  ipBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    backgroundColor: "#f8f9fa",
    border: "1px solid #e0e0e8",
    borderRadius: "8px",
    padding: "0.6rem 1.2rem",
    marginBottom: "1.5rem",
  },
  ipLabel: {
    fontSize: "0.8rem",
    color: "#666",
    fontWeight: "500",
  },
  ipValue: {
    fontSize: "0.95rem",
    fontWeight: "700",
    color: "#1a1a2e",
    fontFamily: "monospace",
    letterSpacing: "0.5px",
  },
};

export default Error403;